<template>
  <div>

    <div class="wrapper">
    </div>
    <div  style="text-align:center; font-size:17px; padding:150px 50px"> Bu alan için kullanım yetkiniz bulunmamaktadır.</div>

    
  </div>
</template>

<script>
export default {
  components:{},
  data() {
    return {
    };
  },
  created (){
      this.$store.setLoading([false,'Bekleyin'])
  },

};
</script>



// WEBPACK FOOTER //
// src/views/info.vue